import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Params, Ventrata} from 'types'
import {useRecaptchaToken, withRecaptchaRetry} from 'utils/recaptcha'
import {ORDER_HEADERS} from './orderHeaders'

export const useConfirmOrderApiMethod = () => {
  const ventrata = useVentrataClient()
  const createRecaptchaToken = useRecaptchaToken()

  return useCallback(
    async ({order, orderIntent}: Params.ConfirmOrder) => {
      if (!order.cardPayment) {
        throw new Error('Card payment is not defined')
      }

      if (order.cardPayment.gateway !== 'adyen') {
        throw new Error('Card payment gateway is not supported')
      }

      if (!order.cardPayment.adyen.session) {
        throw new Error('Adyen session is not defined')
      }

      const sessionId = order.cardPayment.adyen.session.id

      // Every request containing a cardPayment object carries its own freshly
      // generated `purchase` token, nested inside that object, so each payment
      // attempt receives its own Transaction Defense assessment.
      return withRecaptchaRetry('purchase', createRecaptchaToken, async (token) => {
        const recaptchaEnterprise: Params.RecaptchaToken = {token}

        const cardPayment = {
          gateway: 'adyen',
          adyen: {
            sessionId,
          },
          recaptchaEnterprise,
        }

        const {data} = await ventrata.post<Ventrata.Order>(
          `/orders/${order.id}/confirm`,
          {
            contact: orderIntent.contact,
            cardPayment,
          },
          {
            headers: ORDER_HEADERS,
          }
        )

        return data
      })
    },
    [ventrata, createRecaptchaToken]
  )
}
